/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { object, shape, string, func, bool } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import p from 'polyglot/polyglot';

import {
  addTalent as addTalentAction,
  removeTalent as removeTalentAction,
} from 'actions/shortlist';

import Button from 'components/Button/Button';
import BlackTieIcon from 'components/BlackTieIcon/BlackTieIcon';

import styles from './like-button.scss';

/**
 * This is the LikeButton component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class LikeButton extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    history: object.isRequired,
    shortlist: shape({
      likelist_id: string.isRequired,
    }).isRequired,
    talentId: string.isRequired,
    addTalent: func.isRequired,
    removeTalent: func.isRequired,
    slug: string,
    jobId: string,
    callback: func,
    showIcon: bool,
    active: bool,
  };

  static defaultProps = {
    slug: null,
    jobId: null,
    showIcon: false,
    active: false,
    callback: () => {},
  };

  onClick = e => {
    e.preventDefault();

    const {
      auth: { token },
      shortlist: { likelist_id },
      talentId,
      addTalent,
      removeTalent,
      active,
    } = this.props;

    if (active) {
      return removeTalent(token, likelist_id, talentId);
    }
    return addTalent(token, likelist_id, talentId);
  };

  /**
   * Render LikeButton.
   *
   * @return {Object}
   */
  render() {
    const { showIcon, active } = this.props;

    if (showIcon) {
      return (
        <Button
          {...this.props}
          className={styles.likeIcon}
          icon
          dark
          onClick={this.onClick}
          active={false}
        >
          {active && <BlackTieIcon icon="times" weight="btr" />}
          {!active && <BlackTieIcon icon="heart" weight="btr" />}
        </Button>
      );
    }

    return (
      <Button {...this.props} onClick={this.onClick} active={false}>
        {active && p.t('profile.unlike_button')}
        {!active && p.t('profile.like_button')}
      </Button>
    );
  }
}

export default withRouter(
  connect(({ shortlist, auth }) => ({ shortlist, auth }), {
    addTalent: addTalentAction, // @NOTE: This is the new shortlist.
    removeTalent: removeTalentAction, // @NOTE: This is the new shortlist.
  })(LikeButton)
);
